import { Outlet } from 'react-router';
import { Flow } from '@/constants/flow';
import { useCurrentFlow } from '@/hooks/use-flow';
import { StepInputUserInfo } from '@/pages/register/components/step-input-userinfo';
import {
  ExceptionCookieBlocked,
  ExceptionNetworkError,
  ExceptionRequestTimeout,
  ExceptionUnknownError,
} from '../../biz/exception';
import { ExceptionRequestBlocked } from '../../biz/exception/request-blocked';
import { ExceptionSafetyTips } from '../../biz/exception/safety-tips';
import { ExceptionTroubleshooting } from '../../biz/exception/troubleshooting';

export const Flower = () => {
  const { flow } = useCurrentFlow();

  return <StepInputUserInfo />;

  switch (flow) {
    case Flow.EXCEPTION_COOKIE_BLOCKED:
      return <ExceptionCookieBlocked />;

    case Flow.EXCEPTION_REQUEST_BLOCKED:
      return <ExceptionRequestBlocked />;

    case Flow.EXCEPTION_SOMETHING_WENT_WRONG:
      return <ExceptionUnknownError />;

    case Flow.EXCEPTION_SAFETY_TIPS:
      return <ExceptionSafetyTips />;

    case Flow.EXCEPTION_TROUBLESHOOTING:
      return <ExceptionTroubleshooting />;

    case Flow.EXCEPTION_REQUEST_TIMEOUT:
      return <ExceptionRequestTimeout />;

    case Flow.EXCEPTION_NETWORK_ERROR:
      return <ExceptionNetworkError />;

    default:
      return <Outlet />;
  }
};
